<template>
  <DE v-if="lang_mode == 'de'" />
  <EN v-else-if="lang_mode == 'en'" />
  <ES v-else-if="lang_mode == 'es'" />
  <FR v-else-if="lang_mode == 'fr'" />
  <IT v-else-if="lang_mode == 'it'" />
  <KO v-else-if="lang_mode == 'ko'" />
  <ZH v-else-if="lang_mode == 'zh'" />
  <ZHTW v-else-if="lang_mode == 'zh-TW'" />

  <JP v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import JP from '@/components/pages/TermsOfService/JP.vue';
import DE from '@/components/pages/TermsOfService/DE.vue';
import EN from '@/components/pages/TermsOfService/EN.vue';
import ES from '@/components/pages/TermsOfService/ES.vue';
import FR from '@/components/pages/TermsOfService/FR.vue';
import IT from '@/components/pages/TermsOfService/IT.vue';
import KO from '@/components/pages/TermsOfService/KO.vue';
import ZH from '@/components/pages/TermsOfService/ZH.vue';
import ZHTW from '@/components/pages/TermsOfService/ZHTW.vue';

export default {
  name: 'TermsOfServicePage',
  components: {
    JP,
    DE,
    EN,
    ES,
    FR,
    IT,
    KO,
    ZH,
    ZHTW,
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
    lang_mode() {
      if (this.currentUser) {
        return this.currentUser.language;
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
